<template>
    <div
        class="kgr-alert"
        :class="messageClass"
    >
        <div class="kgr-postfix kgr-postfix--center kgr-postfix--smallGutters">
            <div class="kgr-postfix__fixed">
                <kgr-icon
                    icon-class="info-circle"
                    :small="true"
                />
            </div>
            <div
                class="kgr-postfix__fluid kgr-test kgr-text--bold"
            >
                <slot name="headline">{{ defaultHeadline }}</slot>
            </div>
        </div>
        <div>
            <slot name="body"></slot>
        </div>
    </div>
</template>

<script>
import Icon from './icon/Icon';

export default {
    components: {
        'kgr-icon': Icon,
    },
    props: {
        variant: {
            type: String,
            validator: (v) => v === 'warning' || v === 'info',
            default: 'info',
        }
    },
    computed: {
        messageClass() {
            switch(this.variant) {
                case 'warning':
                    return 'kgr-alert--warning';
                default :
                    return 'kgr-alert--info';
            }
        },
        defaultHeadline() {
            switch(this.variant) {
                case 'warning':
                    return this.$t('Warnung')
                default :
                    return this.$t('Hinweis')
            }
        }
    }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    div.kgr-alert {
        margin-bottom: 20px;
    }
</style>
